import type { CommonAddress } from '@models/interfaces/commonAddress';
import { computed, ref, type Ref } from 'vue';
import { getDistrict } from '@tools/address-utils.ts';

export const useStreetDistrict = (addressValue: CommonAddress | Ref<CommonAddress>) => {
  const address: Ref<CommonAddress> = ref(addressValue);

  const capitalizeFirstLetter = (str: string): string => str.charAt(0).toUpperCase() + str.substring(1);

  const formattedAddress = computed<string>(() => {
    if (!address.value.street) {
      return `${address.value.city}, ${address.value.zip_code}`;
    }

    return `${address.value.street.trim()}, ${address.value.city}`;
  });

  const cityDistrict = computed<number | null>(() => getDistrict(address.value.zip_code));

  const formattedStreetDistrict = computed<string>(() => {
    const capitalizedStreetDistrict = capitalizeFirstLetter(formattedAddress.value);

    return cityDistrict.value ? `${capitalizedStreetDistrict} ${cityDistrict.value}` : capitalizedStreetDistrict;
  });

  return {
    formattedAddress,
    cityDistrict,
    formattedStreetDistrict,
  };
};
